import * as React from "react";

const MobileLayout = ({ children }: { children: React.ReactNode }) => (
  <div className="relative m-auto flex h-[100dvh] w-full items-center justify-center overflow-hidden sm:w-[640px]">
    {/* Blurred Background Image */}
    <div
      className="fixed inset-0 scale-105 bg-cover bg-center bg-no-repeat blur-md"
      style={{ backgroundImage: `url(/assets/food-scanning.png)` }}
    />

    {/* Overlay for better contrast */}
    <div className="fixed inset-0 bg-background/70" />

    <div className="relative z-10 flex h-[100dvh] w-full flex-col overflow-y-auto">
      {children}
    </div>
  </div>
);

export default MobileLayout;
